import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-facing-decorator";
import axios from "axios";
import { alertError } from "@/util/dialog";
import { waitingJob } from "@/util/job.utils";
import Loader from "@/components/loader/Loader.vue";
import Icon from "@/components/icon/Icon.vue";
import StandardButton from "@/components/buttons/StandardButton.vue";
const MAX_REGENERATE = 3;
let AIScenarioSelector = class AIScenarioSelector extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "aiFiles", void 0);
    _defineProperty(this, "language", void 0);
    _defineProperty(this, "roles", void 0);
    _defineProperty(this, "loading", true);
    _defineProperty(this, "regenerating", false);
    _defineProperty(this, "errorState", false);
    _defineProperty(this, "scenarios", []);
    _defineProperty(this, "customScenarios", []);
    _defineProperty(this, "selectedScenarioId", "");
    _defineProperty(this, "customScenarioInput", "");
    _defineProperty(this, "customCounter", 0);
    _defineProperty(this, "regenerateCount", 0);
    _defineProperty(this, "seenScenarioIds", new Set());
  }
  get regenerateRemaining() {
    return MAX_REGENERATE - this.regenerateCount;
  }
  mounted() {
    this.loadScenarios();
  }
  loadScenarios() {
    this.loading = true;
    this.errorState = false;
    this.callApi(false);
  }
  onRegenerate() {
    if (this.regenerateCount >= MAX_REGENERATE || this.regenerating) return;
    this.regenerateCount++;
    this.regenerating = true;
    this.callApi(true);
  }
  callApi(isRegenerate) {
    const formData = new FormData();
    this.aiFiles.forEach(f => formData.append('jobIDs', f.jobID));
    formData.append('language', this.language);
    formData.append('rolesJson', JSON.stringify(this.roles.map(r => ({
      id: r.id,
      title: r.title,
      description: r.description || ''
    }))));
    if (isRegenerate) {
      Array.from(this.seenScenarioIds).forEach(id => formData.append('excludeScenarioIds', id));
    }
    axios.post('/recorder/aiSpeachGenerator/suggestScenariosForRoles', formData).then(async resp => {
      await this.handleJobResponse(resp.data, isRegenerate);
    }).catch(e => {
      console.error(e);
      if (isRegenerate) {
        this.regenerating = false;
        alertError(this.$t('aiSpeachGenerator.roleBased.regenerateError'));
      } else {
        this.errorState = true;
        this.loading = false;
      }
    });
  }
  async handleJobResponse(jobID, isRegenerate) {
    try {
      const data = await waitingJob(jobID);
      const result = data;
      this.scenarios = result.scenarios || [];
      for (const s of this.scenarios) {
        this.seenScenarioIds.add(s.id);
      }
      // Drop selection if regenerated set no longer contains it
      if (!this.scenarios.find(s => s.id === this.selectedScenarioId)) {
        this.selectedScenarioId = "";
      }
      if (isRegenerate) {
        this.regenerating = false;
      } else {
        this.loading = false;
      }
    } catch (e) {
      console.error(e);
      if (isRegenerate) {
        this.regenerating = false;
        alertError(this.$t('aiSpeachGenerator.roleBased.regenerateError'));
      } else {
        this.errorState = true;
        this.loading = false;
      }
    }
  }
  selectScenario(scenarioId) {
    this.selectedScenarioId = scenarioId;
  }
  addCustomScenario() {
    const title = this.customScenarioInput.trim();
    if (!title) return;
    const lowerTitle = title.toLowerCase();
    const alreadyExists = this.scenarios.some(s => s.title.toLowerCase() === lowerTitle) || this.customScenarios.some(s => s.title.toLowerCase() === lowerTitle);
    if (alreadyExists) {
      this.customScenarioInput = "";
      return;
    }
    this.customCounter++;
    const newScenario = {
      id: `custom-${this.customCounter}-${lowerTitle.replace(/\s+/g, '-').slice(0, 40)}`,
      title,
      description: ''
    };
    this.customScenarios = [...this.customScenarios, newScenario];
    this.selectedScenarioId = newScenario.id;
    this.customScenarioInput = "";
  }
  removeCustomScenario(scenarioId) {
    this.customScenarios = this.customScenarios.filter(s => s.id !== scenarioId);
    if (this.selectedScenarioId === scenarioId) {
      this.selectedScenarioId = "";
    }
  }
  onValidate() {
    if (!this.selectedScenarioId) return;
    const scenario = this.scenarios.find(s => s.id === this.selectedScenarioId) || this.customScenarios.find(s => s.id === this.selectedScenarioId);
    if (!scenario) return;
    this.$emit('scenarioSelected', scenario);
  }
  onBack() {
    this.$emit('back');
  }
  getDocumentName(documentIndex) {
    const file = this.aiFiles[documentIndex - 1];
    return file?.name || `document_${documentIndex}`;
  }
  formatPages(pages) {
    if (!pages || pages.length === 0) return '';
    const sorted = [...pages].sort((a, b) => a - b);
    const ranges = [];
    let start = sorted[0];
    let prev = sorted[0];
    for (let i = 1; i < sorted.length; i++) {
      if (sorted[i] === prev + 1) {
        prev = sorted[i];
      } else {
        ranges.push(start === prev ? `${start}` : `${start}-${prev}`);
        start = sorted[i];
        prev = sorted[i];
      }
    }
    ranges.push(start === prev ? `${start}` : `${start}-${prev}`);
    return `p.${ranges.join(', ')}`;
  }
};
__decorate([Prop({
  required: true
})], AIScenarioSelector.prototype, "aiFiles", void 0);
__decorate([Prop({
  default: ""
})], AIScenarioSelector.prototype, "language", void 0);
__decorate([Prop({
  required: true
})], AIScenarioSelector.prototype, "roles", void 0);
AIScenarioSelector = __decorate([Component({
  components: {
    Loader,
    Icon,
    StandardButton
  }
})], AIScenarioSelector);
export default AIScenarioSelector;